module.exports = __webpack_public_path__ + "static/media/b1.be6668f.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/penny/b1.mp3
// module id = 9Xan
// module chunks = 0